module.exports = __webpack_public_path__ + "site/img/filter.2b40a0fd.svg";